import React from 'react'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import VCloudList from './VCloudList'
import MerakiList from './MerakiList'

const styles = theme => ({
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
		display: 'flex',
		overflow: 'auto',
		flexDirection: 'column',
	}
});

class ResourcesContent extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		const { classes } = this.props;
		return (
			<Container maxWidth="lg" className={classes.container}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<VCloudList ref="list" client={this.props.client}></VCloudList>
					</Grid>
					<Grid item xs={12}>
						<MerakiList ref="list" client={this.props.client} ></MerakiList>
					</Grid>
				</Grid>
			</Container>
		)
	}
}

export default withStyles(styles)(ResourcesContent)